import type { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { Icon } from '@/components/atoms/Icon';
import { Thumb } from '@/components/atoms/Thumb';
import { EDIT_PROFILE_INFO_DRAWER_IDS, PERSONAL_INFO_DRAWER_ID } from '../utils';
import { getLogoByTheme } from '@/utils/assets';
export const SuccessMessage: FC<SuccessMessageProps> = ({
  resetFlow
}) => {
  const {
    t
  } = useTranslation('common');
  const closeAllDrawersAndReset = () => {
    resetFlow();
    profileDrawers.forEach(id => {
      window.dispatchEvent(new CustomEvent(`close-chakra-modal-${id}`));
    });
  };
  return <Flex flexDir="column" gap="5xl" pt="3xl" data-sentry-element="Flex" data-sentry-component="SuccessMessage" data-sentry-source-file="SuccessMessage.tsx">
      <Thumb src={getLogoByTheme()} width={80} height={35} full fit="contain" alt="Logo EQI+" data-sentry-element="Thumb" data-sentry-source-file="SuccessMessage.tsx" />
      <Flex gap="xl" flexDir="column" data-sentry-element="Flex" data-sentry-source-file="SuccessMessage.tsx">
        <Flex gap="xs" pt="48" data-sentry-element="Flex" data-sentry-source-file="SuccessMessage.tsx">
          <Icon iconName="CheckCircle" h="32" w="32" color="content.brand" data-sentry-element="Icon" data-sentry-source-file="SuccessMessage.tsx" />
          <Text size="l" color="content.primary" data-sentry-element="Text" data-sentry-source-file="SuccessMessage.tsx">
            {t('drawers.personalInfo.success.header')}
          </Text>
        </Flex>
        <Text size="xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="SuccessMessage.tsx">
          {t('drawers.personalInfo.success.description')}
        </Text>
        <Button onClick={closeAllDrawersAndReset} data-sentry-element="Button" data-sentry-source-file="SuccessMessage.tsx">
          {t('attributes.close')}
        </Button>
      </Flex>
    </Flex>;
};
const profileDrawers = [PERSONAL_INFO_DRAWER_ID, ...Object.values(EDIT_PROFILE_INFO_DRAWER_IDS)];
type SuccessMessageProps = {
  resetFlow: () => void;
};